import { Box, Button, Flex, Img, SimpleGrid } from '@chakra-ui/react'
import React from 'react'
import '../Styles/Projects.css'

const projects=[
  {
    "id":1,
    "name":"Everhour",
    "src":"https://raw.githubusercontent.com/Aniket-bansal/EverHour/master/Screenshot_20221015_200049.png",
    "desc":"Everhour is a Non-govt company incorporated on 2010. This organisation has create the time and project management website that helps small and mid sized companies better organize their working hours.Mainly worked on front-end with login functionality thorugh backend.",
    "tech":"The Tech stack used : ReactJs, NodeJs, Express, MongoDb, JavaScript, Chakra-UI, Swiper, CSS.",
    "git":"https://github.com/Aniket-bansal/EverHour",
    "live":"https://everhour-clone-aniket-bansal.vercel.app/"
  },
  {
    "id":2,
    "name":"Netmeds Clone",
    "src":"https://raw.githubusercontent.com/Aniket-bansal/teal-design-3322-Netmeds-Clone-/main/Screenshot%20from%202022-08-18%2012-34-11.png",
    "desc":"Netmeds is the “first-to-market” solution for the quick online purchase and fast delivery of prescription medications. Mainly worked on front-end with login functionality. ",
    "tech":"The Tech stack used : ReactJs, JavaScript, Chakra-UI, Swiper, CSS.",
    "git":"https://github.com/Aniket-bansal/teal-design-3322/tree/main/teal-design-3322",
    "live":"https://awesome-netmeds-clone.netlify.app/",
  },
  {
    "id":3,
    "name":"Dot&Key Clone",
    "src":"https://raw.githubusercontent.com/Bhavesh2302/dot-key-personal/master/Landing%20page.jpg",
    "desc":"Dot & Key is an award-winning skincare company established to transform the idea of 'skincare' into a fun, easy, and acceptable notion. A fresh take on skincare. Through the range of advanced skincare products. Mainly worked on front-end with login functionality.  ",
    "tech":"The Tech stack used : ReactJs, JavaScript, Chakra-UI, Swiper, CSS",
    "git":"https://github.com/Aniket-bansal/Dot-and-key-project" ,
    "live":"https://awesome-dotandkey-clone.netlify.app/",
  },
  
]
const Projects = () => {
  let mode = localStorage.getItem('chakra-ui-color-mode')
  console.log("mode",mode)
  return (
    <Box className='project_main'>
         <Box className='banner'>
         <strong style={{fontSize:"60px",color:"rgb(225, 51, 51)"}}>P</strong>ROJECTS
         </Box>
         <Box className="project_list" width="80%" margin="auto" mt="40px">
         <SimpleGrid columns={[1,1,1,1,2,3]} spacing="10">
          {
            projects.map((item)=>{
              return   <Box className="items"  key={item.id}>
            <Box className="image">
              <Img alt="site_img" src={item.src}/>
            </Box>
            <Box className="desc">
              <strong style={{textAlign:"center"}}><h2>{item.name}</h2></strong><br/>
            <h3>{item.desc}</h3><br/>
            <h3><strong>{item.tech}</strong></h3>
            </Box>
            <Flex className="item_links">
              <a href={item.git} target="_blank" rel="noreferrer"><Button>GitHub</Button></a>
              <a href={item.live} target="_blank" rel="noreferrer"><Button>Live</Button></a>
            </Flex>
          </Box>
        })
      }
         </SimpleGrid>
         </Box>
    </Box>
  )
}

export default Projects